import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { ITrademarkStatisticsQuery } from "../../models/statistcs-trademark/query";
import { ITrademarkStatistics } from "../../models/trademark-statistics/respons";

export type trademarkStatisticsLoading = "list" ;

export interface IInternalState {
  loading: trademarkStatisticsLoading[];

  list?: ITrademarkStatistics;
  query: ITrademarkStatisticsQuery;

}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    setQuery: (query: ITrademarkStatisticsQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const TrademarkStatisticsContext = createContext(externalState);

export default TrademarkStatisticsContext;    
